import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { FormComponent } from '../form.components';
import { validationRules } from '../../../constants';

@Component({
  selector: 'hospitality-bot-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent extends FormComponent {
  @Input() isHideSpinners = false;
  @Input() customTemplate = false;
  @Input() minLength: number;
  @Input() maxLength: number;
  @Input() min: number;
  @Input() max: number;
  @Input() controlName: string;
  @Input() isFocus: boolean;
  @Input() search: boolean = false;

  @Input() manualInputBinding = false;

  strike = false;
  inputLength = 0;
  tempValue = '';
  control!: AbstractControl;

  @Input() viewButton = false;
  @Input() buttonText = 'Save';

  @Output() onManualValueChange = new EventEmitter();
  @Output() onSaveText = new EventEmitter();

  @ContentChild('customTemplateRef') customTemplateRef!: TemplateRef<any>;

  constructor(
    public controlContainer: ControlContainer,
    public el: ElementRef
  ) {
    super(controlContainer);
  }

  ngOnInit(): void {
    const formGroup = this.controlContainer.control as FormGroup;
    this.control = formGroup.get(this.controlName);

    this.tempValue = this.control?.value;

    this.control.valueChanges.subscribe((value) => {
      if (!this.manualInputBinding) return;
      this.tempValue = value;
    });

    this.initInputControl();
    this.listenForInputChanges();
  }

  handleManualInputChange(value: string) {
    if (this.manualInputBinding) {
      this.tempValue = value;
    }
  }

  listenForInputChanges() {
    this.inputControl?.valueChanges.subscribe((value) => {
      //for every changes
      this.validateInput(value);
    });
  }

  applyManualValue() {
    if (this.manualInputBinding) {
      this.control.setValue(this.tempValue);
    }
  }

  resetManualValue() {
    if (this.manualInputBinding) {
      this.tempValue = this.control.value;
    }
  }

  calculateInputLength() {
    if (this.maxLength) {
      this.inputLength = this.inputControl.value?.length ?? 0;
      this.subtitle = `${this.inputLength}/${this.maxLength}`;
    }
  }

  validateInput(inputValue: any) {
    let trimmed = (inputValue ?? '').toString();

    for (const rule of validationRules) {
      if (rule.condition(this.props)) {
        const newValue = rule.apply(trimmed);

        if (newValue !== trimmed) {
          trimmed = newValue;
          this.inputControl.patchValue(trimmed, { emitEvent: false });
        }
      }
    }

    if (trimmed.length === 0) {
      this.inputControl.patchValue(null, { emitEvent: false });
    }
  }

  /**
   *
   * to disable value changes on scroll
   */
  disableValueChangesOnScroll(e) {
    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();
  }

  get getWrapperNgClasses() {
    return {
      ...this.wrapperNgClasses,
      'hide-spinner': this.isHideSpinners,
    };
  }

  get getInputClass() {
    return {
      ...this.inputNgClasses,
      input: true,
      'subtitle-padding': !!this.subtitle?.length,
      'prefix-padding': !!this.prefix?.length,
      'view-cta-btn-padding': this.viewButton,
      'search-padding': this.search,
    };
  }

  handleKeyClick(event: KeyboardEvent) {
    const invalidKeys = ['e', 'E', '+', '-'];
    if (this.type === 'number' && invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
    this.handleKeyDown(event);
    this.handleEnterClick(event);
  }

  handleEnterClick(event: KeyboardEvent): void {
    // Check if the pressed key is Enter and the focus is on the current input field
    if (event.key === 'Enter' && event.target === event.currentTarget) {
      this.onSaveText.emit();
    }
  }

  handleBlur(event?: FocusEvent) {
    if (this.inputControl && typeof this.inputControl.value === 'string') {
      const trimmed = this.inputControl.value.trim();
      if (this.inputControl.value !== trimmed) {
        this.inputControl.patchValue(trimmed.length > 0 ? trimmed : null, {
          emitEvent: true,
        });
      }
    }
    this.onBlur.emit(event);
  }
}
